import { GET_DELIVERY_AGGREGATOR } from '../../constants';
/**
 * @function getContentDeliveryAggregatorAction
 * @description Gets aggregator delivery provider content and stores its values
 * @param payload {Object} - provider content
 * @return {{payload, type: string}}
 */
export default function getContentDeliveryAggregatorAction(payload) {
    return {
        type: GET_DELIVERY_AGGREGATOR,
        payload,
    };
}
